module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1400.341d958e.svg";